import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';
import { IOYIndustryComponetProps, IOYIndustryComponetState } from './const';
import { jeact } from '../../decorators/jeact';

@jeact({ asyncEvent: true })
export default class OYIndustryComponet extends OY<IOYIndustryComponetProps, IOYIndustryComponetState> {
  static displayName = 'OYIndustryComponet';

  static defaultProps: Partial<IOYIndustryComponetProps> = {
    baseUrl: '//cdn-ng.ouyeel.com/statics',
    slideCol: 2
  }

  public state: IOYIndustryComponetState = {
    disableLeft: true,
    disableright: false,
    expinfo: [1, 2, 3, 4, 5, 6]
  };

  $node = {
    leftBtn: $(),
    rightBtn: $(),
    slideContentWrapper: $(),
    slideContent: $(),
    slideItem: $(),
    overallContent: $()
  }

  slideContentWrapperWidth = 0;

  slideContentWidth = 0;

  maxSlideX = 0

  slideX = 0;

  ignoreSlideItemHoverLeave = false;

  ignoreOverallItemHoverLeave = false;

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  componentDidMount() {
    // 计算item宽度
    this.slideContentWrapperWidth = this.$node.slideContentWrapper.width();
    this.slideContentWidth = this.props.data.length * 126;
    this.maxSlideX = this.slideContentWidth - this.slideContentWrapperWidth;
    if (this.slideContentWrapperWidth >= this.slideContentWidth) {
      // 避免全局刷新。直接操作dom更新
      this._setState({ disableright: true })
      this.$node.rightBtn.addClass(styles.disabled)
    }
  }

  setNode(): void {
    this.$node = {
      leftBtn: this.$class(styles.left_btn),
      rightBtn: this.$class(styles.right_btn),
      slideContentWrapper: this.$class(styles.slideContentWrapper),
      slideContent: this.$class(styles.slideContent),
      overallContent: this.$class(styles.overallContent),
      slideItem: this.$class(styles.slideItem)
    }
  }

  bindLeftBtn() {
    this.$node.leftBtn.click((ev: Event) => {
      const $element = $(ev.currentTarget!);
      if ($element.hasClass(styles.disabled)) {
        return;
      }

      const { slideCol } = this.props;
      const offset = slideCol! * 126;
      this.slideX -= offset;
      if (this.slideX <= 0) {
        this.slideX = 0;
        this.$node.leftBtn.addClass(styles.disabled);
      }
      this.$node.rightBtn.removeClass(styles.disabled);
      this.$node.slideContent.css('transform', `translate3d(-${this.slideX}px, 0, 0)`);
    })
  }

  bindRightBtn() {
    this.$node.rightBtn.click((ev: Event) => {
      const $element = $(ev.currentTarget!);
      if ($element.hasClass(styles.disabled)) {
        return;
      }

      const { slideCol } = this.props;
      const offset = slideCol! * 126;

      this.slideX += offset;

      if (this.slideX > this.maxSlideX) {
        this.slideX = this.maxSlideX;
      }

      if (this.slideX >= this.maxSlideX) {
        this.$node.rightBtn.addClass(styles.disabled)
      }

      this.$node.leftBtn.removeClass(styles.disabled);
      this.$node.slideContent.css('transform', `translate3d(-${this.slideX}px, 0, 0)`);
    })
  }

  bindSlideItem() {
    this.$node.slideItem.hover(
      (ev: Event) => {
        this.ignoreSlideItemHoverLeave = false;
        this.ignoreOverallItemHoverLeave = true;

        const $element = $(ev.currentTarget!);
        const index = $element.data('index');
        const width = (790 - 126) / 2;
        const max = this.slideContentWrapperWidth - 790;
        let offset = $element.position().left;
        offset -= width;
        offset -= this.slideX;
        offset = offset < 0 ? 0 : offset;
        offset = offset > max ? max : offset

        // const { left } = $element.get(0).getBoundingClientRect();

        // 更新样式
        this.$node.slideItem.removeClass(styles.hover);
        $element.addClass(styles.hover);

        this.$node.overallContent.hide()
        const $conetnt = $(this.$node.overallContent.get(index));
        $conetnt.css('left', offset + 24).show(0, this.handleOverallconentShow as any);
      },
      (ev: Event) => {
        setTimeout(() => {
          if (this.ignoreSlideItemHoverLeave) {
            return;
          }
          const $element = $(ev.currentTarget!);
          const index = $element.data('index');
          $element.removeClass(styles.hover)

          $element.find(`.${styles.overallContent}`).hide();

          const $conetnt = $(this.$node.overallContent.get(index));
          $conetnt.hide();
        }, 100);
      }
    ).click((ev: Event) => {
      const $element = $(ev.currentTarget!);
      const value = $element.data('value');
      const name = $element.data('name');
      this._handleClick(name, value)
    })
  }

  bindOverallContent() {
    this.$node.overallContent.hover(
      (ev: Event) => {
        this.ignoreSlideItemHoverLeave = true;
        this.ignoreOverallItemHoverLeave = false;
      },
      (ev: Event) => {
        setTimeout(() => {
          if (this.ignoreOverallItemHoverLeave) {
            return;
          }
          const $element = $(ev.currentTarget!);
          const index = $element.data('index');
          $element.hide();
          const $item = $(this.$node.slideItem.get(index));
          $item.removeClass(styles.hover)
        }, 100)
      }
    )
  }

  bindExplodedBtnClick() {
    this.$el.find(`.${styles.explodedBtn}`).click((ev: Event) => {
      const $element = $(ev.currentTarget!);
      const value = $element.data('value');
      const name = $element.data('name');
      this._handleClick(name, value)
    })
  }

  private handleOverallconentShow() {
    const $this = $(this);
    const load = $this.data('load');
    if (!load) {
      const $left = $this.find(`.${styles.overallContent_left}`);
      $left.append(`<img src="${$left.data('src')}">`)
      const $right = $this.find(`.${styles.overallContent_right}`);
      $right.append(`<img src="${$right.data('src')}">`);

      const $expright = $this.find(`.${styles.overallContent_explodedRight}`);
      $expright.append(`<img src="${$expright.data('src')}">`)
      $this.data('load', true);
    }
  }

  private _handleClick(name: string, value: string) {
    this.eventEmitter.emit(EEventType.onClick, name, value);
    this.$node.slideItem.removeClass(styles.hover);
    this.$node.overallContent.hide();
  }
}



// WEBPACK FOOTER //
// ./src/components/OYIndustryComponet/index.ts